// Copyright 2015, Mike Bostock
// BSD 3-Clause License — https://github.com/d3/d3-sankey/blob/main/LICENSE
// Vendored from d3-sankey@0.12.3 — https://github.com/d3/d3-sankey

// All fields optional so SankeyNode<N,L> (which has optional geometry) is assignable here.
// sourceLinks/targetLinks are ReadonlyArray<unknown> so SankeyLink<N,L>[] (where target can be
// string | number | SankeyNode) satisfies the constraint via assignability to unknown.
interface NodeForAlign {
  depth?: number;
  height?: number;
  sourceLinks?: ReadonlyArray<unknown>;
  targetLinks?: ReadonlyArray<unknown>;
}

export function justify(node: NodeForAlign, n: number): number {
  return (node.sourceLinks?.length ?? 0) > 0 ? node.depth ?? 0 : n - 1;
}

export function left(node: NodeForAlign): number {
  return node.depth ?? 0;
}

export function right(node: NodeForAlign, n: number): number {
  return n - 1 - (node.height ?? 0);
}
